import script from "./chip-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./chip-form.vue?vue&type=script&lang=ts&setup=true"

import "./chip-form.vue?vue&type=style&index=0&id=024c3a43&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024c3a43"]])

export default __exports__